'use client';
import Image from 'next/image';
import { motion } from 'framer-motion';
import { Eyebrow } from './section-heading';

export function LandingHero() {
  return (
    <section className="border-t border-[#948780]/40 bg-[#cdc4c1] px-5 md:px-10 lg:px-22 4xl:px-50">
      <div className="grid items-center gap-12 pt-16 pb-16 md:grid-cols-[1.15fr_1fr] md:gap-16 md:pt-24 md:pb-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <Eyebrow className="mb-6">Wee Amici &middot; Houston</Eyebrow>
          <h1 className="font-cinzel text-[34px] leading-[1.1] font-bold text-[#231f20] uppercase md:text-[52px] 2xl:text-[64px]">
            Navigate parenting with a{' '}
            {/* Large text (34px+ bold) only needs 3:1, so the accent can stay
                lighter than body copy — #6B615B clears it at 3.52:1 on #cdc4c1. */}
            <span className="text-[#6B615B]">private network.</span>
          </h1>
          <p className="font-merriweather mt-6 max-w-md text-sm leading-relaxed text-[#45423d] md:text-base">
            A private network where parents connect with other parents on the
            issues that matter to them — so their children can thrive. Real
            questions, real answers, and the people, providers, and businesses
            your family can actually count on.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#waitlist"
              className="font-cinzel rounded-full bg-[#786D67] px-7 py-3 text-[13px] font-bold tracking-[0.14em] text-white uppercase transition-colors hover:bg-[#5F5751]"
            >
              Join the waitlist
            </a>
            <a
              href="#about"
              className="font-cinzel inline-flex items-center gap-2 border-b border-[#231f20] pb-1.5 text-[12px] font-semibold tracking-[0.18em] text-[#231f20] uppercase transition-colors hover:border-[#948780] hover:text-[#554E49]"
            >
              Read our story
              <span aria-hidden>&darr;</span>
            </a>
          </div>
        </motion.div>

        <motion.div
          className="relative mx-auto aspect-[4/5] w-full max-w-sm md:max-w-none"
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, delay: 0.15 }}
        >
          <Image
            unoptimized
            src="/HomeImages/testimonials_image.webp"
            alt="A Wee Amici parent and child"
            fill
            sizes="(min-width: 768px) 40vw, 90vw"
            className="object-cover object-[50%_22%]"
          />
        </motion.div>
      </div>
    </section>
  );
}
